import React from "react";

const Education = () => {
  return (
    <div className="edu-exp-container">
      <h3 className="edu-exp-title">Education</h3>
      <div className="edu-exp-content">
        <p>
          <strong>General Assembly:</strong> Software Engineering Bootcamp
          (2023-2024)
        </p>
        <p>
          <strong>Open University:</strong> Science, Maths and Tech access
          course (A-levels) – 95% Distinction (2020)
        </p>
        <p>
          <strong>City University:</strong> Human Resources Management Course
          (2009)
        </p>
        <p>
          <strong>City of Westminster College:</strong> Level 3 NVQ in Business
          Administration (2004-2005)
        </p>
      </div>
    </div>
  );
};

export default Education;
